import { apiClient } from "@apis/apiClient";
import apiUtils from "@apis/apiUtils";
import type {
  ApiResponse,
  Channel,
  ChannelData,
  CreateChannelParams,
  UpdateChannelParams,
  PushDataParams,
  GetChannelDataParams,
} from "./channelClient.dto";

const channelClient = {
  findByOrg(
    orgId: string | number,
    category?: string
  ): Promise<ApiResponse<Channel[]>> {
    const param = category ? `?category=${category}` : "";
    return apiClient.get(`/rest/channels/org/${orgId}${param}`);
  },

  findByOrgAndCategories(
    orgId: string | number,
    categories: string[]
  ): Promise<ApiResponse<Channel[]>> {
    console.log("findByOrgAndCategories categories", categories);
    return apiClient.post(`/rest/channels/categories/org/${orgId}`, categories, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  findOne(channelId: string): Promise<ApiResponse<Channel>> {
    return apiClient.get(`/rest/channels/${channelId}`);
  },

  getLastDataChannelsOfDevice(deviceId: string): Promise<ApiResponse<ChannelData[]>> {
    return apiClient.get(`/rest/channels/data/device/${deviceId}`);
  },

  pushData(params: PushDataParams): Promise<ApiResponse<void>> {
    return apiClient.post(
      `/rest/channels/pushData/device/${params.id}/channel/${params.channelId}`,
      params.data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getDataByDeviceAndChannel(
    params: GetChannelDataParams,
    cancelToken?: unknown
  ): Promise<ApiResponse<ChannelData[]>> {
    return apiClient.get(
      apiUtils.buildParamsListURI(`/rest/channels/device/`, params),
      cancelToken ? ({ cancelToken } as never) : undefined
    );
  },

  create(params: CreateChannelParams): Promise<ApiResponse<Channel>> {
    return apiClient.post(`/rest/channels`, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  update(
    id: string,
    params: UpdateChannelParams
  ): Promise<ApiResponse<Channel>> {
    return apiClient.put(`/rest/channels/${id}`, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  delete(id: string): Promise<ApiResponse<void>> {
    return apiClient.delete(`/rest/channels/${id}`);
  },

  deleteData(id: string, deviceId: string): Promise<ApiResponse<void>> {
    return apiClient.delete(`/rest/channels/${id}/data/${deviceId}`);
  },
};

export { channelClient };
export default channelClient;
